import { Avatar, Badge, Table, Group, Text, Loader } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { CopyableId } from '../copyableId/CopyableId';

export function UsersTable({ data, filter, loading, error }) {
    const navigate = useNavigate();

    if (loading) {
        return <Loader />;
    }

    if (filter && filter !== 'All') {
        data = data.filter((item) => (item.brands).find((brand) => brand.id === filter));
    }

    const rows = data.map((item) => (
        <Table.Tr
            key={item.id}
            style={{ cursor: 'pointer' }}
            onClick={() => navigate(`/admin/users/${item.id}`)}
        >
            <Table.Td>
                <CopyableId id={item.id} label="User ID" />
            </Table.Td>
            <Table.Td>
                <Group gap="sm">
                    <Avatar size={30} src={item.image} radius={30} />
                    <Text fz="sm" fw={500}>
                        {item.name}
                    </Text>
                </Group>
            </Table.Td>

            <Table.Td>
                <Text fz="sm">{item.phone}</Text>
            </Table.Td>

            <Table.Td>
                <Badge variant="dark" size='lg'>
                    {item.stampsCount}
                </Badge>
            </Table.Td>

            <Table.Td>
                <Badge variant="dark" size='lg'>
                    {item.rewardsCount}
                </Badge>
            </Table.Td>

            <Table.Td>
                <Badge variant="dark" size='lg'>
                    {item.brandsCount}
                </Badge>
            </Table.Td>

        </Table.Tr>
    ));

    return (
        <>
            <Table.ScrollContainer minWidth={800}>
                <Table verticalSpacing="sm">
                    <Table.Thead>
                        <Table.Tr>
                            <Table.Th>ID</Table.Th>
                            <Table.Th>User</Table.Th>
                            <Table.Th>Phone</Table.Th>
                            <Table.Th>Stamps</Table.Th>
                            <Table.Th>Rewards</Table.Th>
                            <Table.Th>Brands</Table.Th>
                        </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>{rows}</Table.Tbody>
                </Table>
            </Table.ScrollContainer>
        </>
    );
}
